<div class="footer"><p>{{ msg }}</p></div>